import React, { useState } from 'react';
import { Container, Paper } from '@material-ui/core';

import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import Navbar from './components/Navbar/Navbar';
import Home from './components/Home/Home';
import Auth from './components/Auth/Auth';
import PostDetails from './components/PostDetail/PostDetails';

import { ThemeProvider } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

//import "./App.css";

const App = () => {
  const [darkMode, setDarkMode] = useState(false)
  const user = JSON.parse(localStorage.getItem('profile'));
  //const userTheme = JSON.stringify(localStorage.setItem('theme'));

  const theme = createTheme({ 
    palette: {
      type: darkMode ? 'dark' : 'light',
    }
  })

  const handleThemeChange = () => {
    setDarkMode(!darkMode)
  }

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Paper style={{ padding: "5px 20px 20px 20px" }}>
          <Container maxWidth='xl'>
            <Navbar darkMode={darkMode} onChange={handleThemeChange} />
            <Switch>
              <Route
                exact
                path='/'
                component={() => <Redirect to='/posts' />}
              />
              <Route exact path='/posts' component={Home} />
              <Route exact path='/posts/search' component={Home} />
              <Route exact path='/posts/:id' component={PostDetails} />
              <Route
                exact
                path='/auth'
                component={() => (!user ? <Auth /> : <Redirect to='/posts' />)}
              />
            </Switch>
          </Container>
        </Paper>
      </ThemeProvider>
    </Router>
  );
};

export default App;
